<template>
  <div>
    <v-btn
      absolute
      dark
      fab
      top
      right
      color="primary"
      style="top: 10px"
      @click="promotionDialog = true"
      v-if="!isEditPromotion"
    >
      <v-icon color="black">add</v-icon>
    </v-btn>
    <promotionForm
      :selected_item="selected_item"
      :dialog="promotionDialog"
      @setDialog="promotionDialog = $event"
      :editedIndex="editedIndex"
      @setEditIndex="editedIndex = $event"
      @onSaved="
        promotionList = $event;
        editedIndex = -1;
        promotionDialog = false;
      "
    />
    <v-layout row>
      <v-flex xs12>
        <v-toolbar dense flat>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search promotion code / name"
            single-line
            hide-details
            style="padding: 0"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="filteredPromotionList"
      :pagination.sync="pagination"
      :loading="loading_message"
      :rows-per-page-items="[25, 50, 100, 500, 1000, 2000]"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">
          {{ promotionList.indexOf(props.item) + 1 }}
        </td>
        <td class="text-xs-left">{{ filterOrderType(props.item) }}</td>
        <td class="text-xs-left">{{ props.item.promotion_code }}</td>
        <td class="text-xs-left">{{ props.item.promotion_name_th }}</td>
        <td class="text-xs-left">{{ filterPromoType(props.item) }}</td>
        <td class="text-xs-right">
          {{
            props.item.promotion_discount + " " + filterPromoUnit(props.item)
          }}
        </td>
        <td
          class="text-xs-right"
          v-if="props.item.promotion_province_condition.length > 0"
        >
          {{
            props.item.promotion_province_condition[0].used_amount +
            " / " +
            props.item.promotion_province_condition[0].total_amount
          }}
        </td>
        <td v-else></td>
        <td class="text-xs-center">{{ props.item.promotion_start_date }}</td>
        <td class="text-xs-center">{{ props.item.promotion_end_date }}</td>
        <td class="text-xs-center">
          <v-tooltip top>
            <v-btn
              icon
              slot="activator"
              :to="
                '/weserve_admin_login/-/promotion-manage/promotion-log/' +
                props.item.promotion_id
              "
            >
              <v-icon small>remove_red_eye</v-icon>
            </v-btn>
            <span>View log</span>
          </v-tooltip>
        </td>
        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn icon @click="editPromotion(props.item)" slot="activator">
              <v-icon small>edit</v-icon>
            </v-btn>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn
              icon
              slot="activator"
              :loading="deletingPromoId.includes(props.item.promotion_id)"
              @click="deletePromotion(props.item)"
              v-if="!isEditPromotion"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
        </td>
      </template>

      <template slot="no-data">
        <div v-if="loading_message == false">No data available</div>
        <div v-else>
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular
          >Loading data ...
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import promotionForm from "./PromotionForm";
import { mapState, mapGetters } from "vuex";
export default {
  data: () => ({
    deletingPromoId: [],
    promotionList: [],
    loading_message: false,
    selected_item: {},
    search: "",
    promotionDialog: false,
    dialog: false,
    editedIndex: -1,
    pagination: {
      rowsPerPage: 25,
    },
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
        value: "name",
      },
      {
        text: "Order type",
        align: "center",
        value: "promotion_order_type_name_temp",
        sortable: false,
      },
      {
        text: "Code",
        align: "center",
        value: "promotion_code",
        sortable: false,
      },
      {
        text: "Name",
        align: "center",
        value: "promotion_name_th",
        sortable: false,
      },
      {
        text: "Type",
        align: "center",
        value: "promotion_type_name_temp",
        sortable: false,
      },
      {
        text: "Discount",
        align: "center",
        value: "promotion_discount",
        sortable: false,
      },
      {
        text: "Used / Total",
        align: "center",
        value: "promotion_amount",
        sortable: false,
      },
      {
        text: "Start",
        align: "center",
        value: "promotion_start_date",
        sortable: false,
      },
      {
        text: "End",
        align: "center",
        value: "promotion_end_date",
        sortable: false,
      },
      {
        text: "Log",
        align: "center",
        value: "name",
        sortable: false,
      },
      {
        text: "Action",
        align: "center",
        value: "name",
        sortable: false,
      },
    ],
  }),
  components: {
    promotionForm,
  },
  computed: {
    ...mapGetters({
      isEditPromotion: "isEditPromotion",
    }),
    filteredPromotionList() {
      return this.promotionList.filter(
        (val) =>
          val.promotion_code
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          val.promotion_name_th
            .toLowerCase()
            .includes(this.search.toLowerCase())
      );
    },
    pages() {
      this.pagination.totalItems = this.promotionList.length;
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.loading_message = true;
      this.promotionList = await this.$store.dispatch(
        "fetchFoodPromotionBack/fetchPromoListAllProvince"
      );
      this.loading_message = false;
    },
    filterPromoUnit(item) {
      if (item.promotion_unit == 1) {
        return "฿";
      } else {
        return "%";
      }
    },
    filterPromoType(item) {
      if (item.promotion_order_type == 5) {
        if (item.promotion_type == 3) {
          return "Total";
        }
      }

      if (item.promotion_type == 1) {
        return "Product";
      } else if (item.promotion_type == 2) {
        return "Transfer";
      } else if (item.promotion_type == 3) {
        return "Product and transfer";
      }

      return "Other";
    },
    filterOrderType(item) {
      if (item.promotion_order_type == 1) {
        return "Food";
      } else if (item.promotion_order_type == 2) {
        return "Messenger";
      } else if (item.promotion_order_type == 3) {
        return "Free";
      } else if (item.promotion_order_type == 4) {
        return "Wellness";
      } else if (item.promotion_order_type == 5) {
        return "Car hiring";
      }
      return "Other";
    },
    async deletePromotion(item) {
      let check = confirm("Do you want to delete this promotion ?");
      if (check == true) {
        this.deletingPromoId.push(item.promotion_id);
        let result = await this.$store.dispatch(
          "fetchFoodPromotionBack/deletePromotionAllProvince",
          item.promotion_id
        );
        let indexDelete = this.deletingPromoId.findIndex(
          (val) => val == item.promotion_id
        );
        this.deletingPromoId.splice(indexDelete, 1);
        if (result == false) return;
        let index = this.promotionList.findIndex(
          (val) => val.promotion_id == item.promotion_id
        );
        this.promotionList.splice(index, 1);
      }
    },
    editPromotion(item) {
      this.selected_item = item;
      this.promotionDialog = true;
      this.editedIndex = 1;
    },
  },
};
</script>
